import { SaleModule } from 'utils/types/AnalysisModels';
import { Module } from 'utils/types/SaleModels';

export const getNormalizedSaleModuleName = (moduleName: Module | SaleModule) => {
    return moduleName.split('_')[1].toLowerCase();
};
